import messaging from '@react-native-firebase/messaging';
import { useEffect, useRef, useState } from 'react';
import { Appearance, Dimensions, EmitterSubscription, Platform } from 'react-native';

import { EAppTheme, EThemeScheme } from '@webtrader/core/themes';

export const checkIsIos = () => {
  return Platform.OS === 'ios';
};

export const checkIsAndroid = () => {
  return Platform.OS === 'android';
};

export const requestPermissionForNotifications = async () => {
  // Permissions enabled -> AuthorizationStatus.AUTHORIZED || AuthorizationStatus.PROVISIONAL
  await messaging().requestPermission();
};

export const isPortrait = () => {
  const dimensions = Dimensions.get('screen');

  return dimensions.height >= dimensions.width;
};

export const useDeviceDimensions = (callback?: (nextHeight: number) => void) => {
  const [height, setHeight] = useState(Dimensions.get('screen').height);
  const [dimension, setDimension] = useState<EmitterSubscription>();
  const ref = useRef(false);

  if (!ref.current) {
    const dimensionChangeListener = Dimensions.addEventListener('change', (handler) => {
      const nextHeight = handler.screen.height;
      setHeight(nextHeight);
      callback?.(nextHeight);
    });
    setDimension(dimensionChangeListener);
    ref.current = true;
  }

  useEffect(() => {
    return () => {
      dimension?.remove();
    };
  }, [callback, dimension]);

  return {
    height
  };
};

export const schemeToTheme = (scheme: EThemeScheme) => {
  switch (scheme) {
    case EThemeScheme.DARK:
      return EAppTheme.DARK;
    case EThemeScheme.SYSTEM:
      return Appearance.getColorScheme() === 'dark' ? EAppTheme.DARK : EAppTheme.LIGHT;
    default:
      return EAppTheme.LIGHT;
  }
};

/**
 * Default delay duration (in ms) to allow switching of modals on React Native
 * Primarily used for iOS mobile app
 * */
export const defaultModalOpenDelay: number = 750;
